import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Typography,
  Avatar,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import {
  Home as HomeIcon,
  Forum as ForumIcon,
  Dashboard as DashboardIcon,
  ManageAccounts as ManageAccountsIcon,
  Article as ArticleIcon,
  Logout as LogoutIcon,
  Menu as MenuIcon,
  Work as WorkIcon,
} from "@mui/icons-material";
import { useSelector } from "react-redux";

function LeftSidebar({ collapsed, setCollapsed }) {
  const user = useSelector((state) => state.users);
  const userRole = useSelector((state) => state?.users?.role);
  const navigate = useNavigate();

 
  const routes = [
    {
      path: "/app/dashboard",
      icon: <HomeIcon sx={{ color: "#FFFFFF" }} />,
      name: "Home",
    },
    {
      path: "/app/Admin",
      icon: <DashboardIcon sx={{ color: "#FFFFFF" }} />, 
      name: "Admin Dashboard",
      role: "admin",
    },
    {
      path: "/app/PostManagement",
      icon: <ManageAccountsIcon sx={{ color: "#FFFFFF" }} />, 
      name: "Post Management",
      role: "admin",
    },
    {
      path: "/app/Discussion",
      icon: <ForumIcon sx={{ color: "#FFFFFF" }} />, 
      name: "Discussion Forum",
    },
    {
      path: "/app/project-management",
      icon: <WorkIcon sx={{ color: "#FFFFFF" }} />,
      name: "Project Management",
    },
   
    {
      path: "/app/UserPostManagement",
      icon: <ArticleIcon sx={{ color: "#FFFFFF" }} />,  
      name: "User Post Management",
      role: ["faculty", "admin"],
    },
  ];

  const filteredRoutes = routes.filter((route) => {
    if (userRole?.toLowerCase() === 'admin' && route.role !== 'faculty') return true;
    if (userRole?.toLowerCase() === 'faculty' && route.role !== 'admin') return true;
    return route.name === 'Home' || route.name === 'Discussion Forum';
  });

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const logoutUser = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div
      className={`flex flex-col h-screen fixed transition-all duration-300 ${collapsed ? "w-16" : "w-64"}`}
      style={{
        backgroundColor: "#3f51b5",
        backgroundImage: "linear-gradient(to top, #4E65FF, #92EFFD)",
        zIndex: 30,
      }}
    >
      <div className="flex justify-between">
        <IconButton onClick={toggleSidebar} className="text-white">
          <MenuIcon fontSize="large" />
        </IconButton>
      </div>

      {!collapsed && (
        <div className="flex flex-col items-center space-y-3 py-1 border-b border-gray-300">
          <Avatar
            alt={user.name}
            src={user?.profileImage}
            className="w-16 h-16 shadow-lg"
          />
          <Typography variant="h6" className="font-semibold text-lg text-white">
            {user.name}
          </Typography>
          <Typography variant="body2" className="text-gray-200 text-sm italic">
            {userRole ? userRole : "User Role"}
          </Typography>
        </div>
      )}

      <Box sx={{ py: "1vh" }} className="flex-1">
        {/* Render all routes as single-level menu items */}
        {filteredRoutes.map((item, index) => (
          <Link
            to={item.path}
            key={index}
            className={`block py-4 px-3 hover:bg-blue-700 transition-colors duration-150`}
          >
            <Typography sx={{ color: "white" }} className="flex items-center">
              {item.icon}
              {!collapsed && <span className="ml-2">{item.name}</span>}
            </Typography>
          </Link>
        ))}
      </Box>

      <Button
        sx={{
          color: "white",
          display: "flex",
          flexDirection: 'column',
          borderTop: "3px solid #d1d5db",
          py: "1vh",
          mb: "10vh"
        }}
        startIcon={!collapsed && <LogoutIcon className="text-white" />}
        onClick={logoutUser}
      >
        {!collapsed ? (
          <span>Logout</span>
        ) : (
          <div className="flex flex-col items-center">
            <LogoutIcon className="text-white" />
          </div>
        )}
      </Button>
    </div>
  );
}

export default LeftSidebar;
